<template>
		<div>
		<TopAppBar
			:leftBtnMode="leftBtnMode"
			:rightBtnMode="rightBtnMode"
			:title="title"
			:leftBtnMethod="leftBtnMethod"
			:rightBtnMethod="rightBtnMethod"
      :hideCategory="true"
			staticMode="true"
		>
		</TopAppBar>

		<div class="d-flex h-full flex-column">
				<TopAppBarDrawer></TopAppBarDrawer>
	<main class="main-wrapper flex-grow-1">
	<!-- <div class="t-headline11 t-color-headlineBlack pda-16 t-center font-m">전체 강의</div> -->
	<div class="container pdt-50">
					<div class="t-color-headlineBlack t-headline15 font-b">{{$t('3204')}}</div>
					<div class="divider mgt-24"></div>
	</div>
	<div class="container mgt-24 pdb-50">
					<div class="d-flex mgb-16 flex-wrap"  v-if="popularTag && popularTag.length">
						<template 	v-for="(tag, index) in popularTag">
									<div
									:key="index"
									v-if="firstSelectedTags.includes(tag.id)"
									class="pdl-8 pdr-12 mgr-8 mgt-4 t-body6 font-r t-color-contentBlue bg-contentBlueInactive h-32 t-center b-radius4 d-flex align-items-center">
													#{{tag.name}}
									</div>
									</template>
					</div>
				<div class="d-grid-3-24" v-if="boardCommunityData && boardCommunityData.content && boardCommunityData.content.length">
					<div v-for="(boardData, indexBoard) in boardCommunityData.content" :key="indexBoard+'_board'">
						<div class="mdc-card  mgb-24 pdt-24 pdb-12 ">
							<div class="pdl-24 pdr-24">
								<div class="d-flex">
									<div class="list-image-small">
										<img
												v-if="boardData.auditor.register.profile"
												:src="boardData.auditor.register.profile"
												class="circle icon52 h-52" alt="" />
										<img v-else src="/images/user.png" class="circle icon52 h-52" alt="">
									</div>

									<div class="flex-grow-1 pdl-16">
										<div class="d-flex justify-content-between">
											<div class="t-body3 mgb-1 font-r mgb-4">{{ boardData.auditor.register.name.fullName }}</div>
										</div>
										<div class="t-body3 font-r t-color-bodyGrayA">{{ $moment(boardData.auditor.register.time).format("L") }}</div>
									</div>
								</div>
								<div class="t-body3 font-r mgt-24 cursor-pointer " tabindex="0" @click="moveToDetail(boardData, 'community')" @keypress="moveToDetail(boardData, 'community')">{{boardData.contents? boardData.contents.subject:''}}</div>
								<div class="t-body6 font-r t-color-bodyGrayA mgt-8 l-spacing45 t-line-h-25 cursor-pointer" tabindex="0" @click="moveToDetail(boardData, 'community')" @keypress="moveToDetail(boardData, 'community')" v-if="boardData.contents && boardData.contents.body !== ''">
									<span v-html="listFilter(boardData.contents.body)"></span>
								</div>
								<div
								v-if="(boardData.contents.video || boardData.contents.images) && (getType(boardData.contents.video.contentType) === 'video' || (boardData.contents.images.length > 0 && getType(boardData.contents.images[0].contentType) === 'image'))"
									class="mgt-16 b-radius4 position-relative d-flex align-items-center justify-content-center mgb-8 square-image">

									<img v-if="boardData.contents.images && boardData.contents.images.length > 0 && getType(boardData.contents.images[0].contentType) === 'image'"
											:src="boardData.contents.images[0].resourceUri"
											class="position-relative cursor-pointer" id="video-overlay"
											@click="moveToDetail(boardData, 'community')" @keypress="moveToDetail(boardData, 'community')" tabindex="0"
										alt="">
										<video-player
											class="video-player-box"
											v-if="boardData.contents.video && getType(boardData.contents.video.contentType) === 'video'"
											ref="videoPlayer"
											:options="getPayerOption(boardData.contents.video)"
											:playsinline="true"
										/>

								</div>
								<div class="d-flex mgt-4 flex-wrap" v-if="boardData.tags && boardData.tags.length > 0">
									<div
										v-for="(tag, i) in boardData.tags" :key="i"
										class="pdl-4 pdr-4 b-radius2 mgr-4 mgt-4 t-body3 font-r t-color-contentBlue bg-contentBlueInactive min-h-22 t-center">
										#{{ tag.name }}
									</div>
								</div>
							</div>
							<div class="divider mgt-16"></div>
							<div class="d-flex  pdt-16 pdb-12 pdl-24 pdr-24">
								<div class="t-helper t-color-bodyGrayA font-r">{{$t("3118", { str:boardData?boardData.commentCount:'0'})}}</div>
							</div>
						</div>
					</div>
				</div>
				</div>
			</main>
		</div>
		</div>
</template>
<script>
import TopAppBar from "@/components/TopAppBar.vue";
import TopAppBarDrawer from "@/components/TopAppBarDrawer.vue";

import { topAppBarMixin } from "../../mixins/topAppBar.js";
import mainApi from "@/api/mainApi.js";
import {mapState} from 'vuex'
import 'video.js/dist/video-js.css'
import { videoPlayer } from 'vue-video-player'

export default {
	name: "TagSerachCourse",
	components: {
		TopAppBar,
		TopAppBarDrawer,
		videoPlayer
	},
		data() {
		return {
			popularTag : null,
   boardCommunityData : null,
			firstSelectedTags:[]
		};
	},

	computed: {

	},

	mixins: [topAppBarMixin],
	mounted() {
		this.firstSelectedTags = this.$route.query.tags.split(",").map(Number);
  // fetch all tags data
			mainApi
			.fetchPopularTag()
			.then((response) => {
				this.popularTag = response.data.data;
			})
			.catch((err) => { });
			let params = {size: 10, tags: this.$route.query.tags}
		mainApi.fetchPopularTagCommunity(params)
			.then((response) => {
				console.log(response)
				this.boardCommunityData = response.data.data;
			})
			.catch((err) => {
				console.log(err)
				let responseData = err.response.data.meta;
				this.$error({ content: responseData.errMsg }).then(() => {});
			});
	},
	methods : {
		// Move to community detail
		moveToDetail(record, type) {
			if (record && record.id) {
				this.$router.push('/board/'+record.boardDto.identifier+'/'+record.id+'?boardName='+encodeURI(record.boardDto.name)+'&categoryName='+encodeURI(record.boardDto.boardCategory.name))
			}
		},
		// check image or video
		getType(contentType) {
			return contentType.split('/')[0]
		},
		// apply limited char
		listFilter(str){
			let length = 90;
			let ending = ' ...';
			let str1='';
			if (str.length > length) {
				str1 = str.substring(0, length - ending.length) + ending;
				return str1.replace(/(\r\n|\n|\r)/gm, '<br/>')
			} else {
				return str.replace(/(\r\n|\n|\r)/gm, '<br/>');
			}
		},
	}
}
</script>
<style scoped>
.container.main-swiper-container.new-survey img{
				border-top-left-radius: 50%;
    border-top-right-radius: 50%;
}
html[dir="rtl"] .container.main-swiper-container.new-survey img{
				border-top-right-radius: 50%;
    border-top-left-radius: 50%;
}
</style>
